module.exports = __webpack_public_path__ + "static/media/filename (3).a867788b.png";